<!-- display-mobile-21 preview — a native in-article unit: the square creative
     on the left, and a copy column carrying the headline, the description and a
     row that pairs the disclosure chip and the advertiser with an outlined
     action button. Closest to placement 4, which draws the same unit at the head
     of the page instead of inside the article. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in, ending on a paragraph's short line -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <i class="bi bi-info-circle da-adchoices"></i>

      <div class="da-ad-row d-flex flex-row">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing" [title]="missingDimensionLabel">{{ missingDimensionShortLabel }}</div>
        </a>

        <div class="da-copy">
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <div class="da-footer d-flex flex-row align-items-center">
            <!-- The mock is a Croatian preview, so Google's own label reads
                 "Oglas" there; it stays English here like the other placements,
                 since the network localises it at serve time. -->
            <span class="da-badge">Ad</span>

            <!-- GenSingleImagePreviewData carries no advertiser field, so the name
                 is a literal here, the same compromise the other placements make. -->
            <span class="da-advertiser">Valamar</span>

            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta ms-auto">
              {{ data.ctaText || "Your call to action" }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad, to the bottom of the screen -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
